import {Button} from '@mui/material';
import {EmptySearchState} from 'presentation/components';
import {HandleMessage} from 'presentation/components/HandleMessage';
import {Loading} from 'presentation/components/Loading/Loading';
import {ChatRoomsEnum} from 'presentation/constants';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {FlowEnum} from '../../../constants/flowEnum';
import {SpecialtyOrExamNotFoundProps} from './types';

const {specialtyNotFound} = translations['pt-br'].privateFlow.bookingFlow;

const SpecialtyOrExamNotFound = ({handlePrimaryButton, flowType}: SpecialtyOrExamNotFoundProps) => {
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const handleCallChatRoom = async () => {
		await callChatRoom(ChatRoomsEnum.APP);
	};
	const varTitle = flowType === FlowEnum.EXAM ? 'exames' : 'especialidades';
	const isOdontoFlow = flowType === FlowEnum.ODONTO;

	return (
		<EmptySearchState
			title=""
			customTitle={
				<HandleMessage
					message={isOdontoFlow ? specialtyNotFound.titleOdonto : specialtyNotFound.title}
					variables={[varTitle]}
				/>
			}
			description={specialtyNotFound.description}>
			<Button onClick={handlePrimaryButton} size="large">
				{specialtyNotFound.primaryButton}
			</Button>
			<Button
				onClick={handleCallChatRoom}
				variant="outlined"
				size="large"
				disabled={callChatRoomIsLoading}
				endIcon={callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null}>
				{specialtyNotFound.secondaryButton}
			</Button>
		</EmptySearchState>
	);
};

export {SpecialtyOrExamNotFound};
